import React from 'react';

import { IconButton, Tooltip } from '@zapier/design-system';

type Props = {
  message: string;
};

function LockedNavCog({ message }: Props) {
  return (
    <Tooltip content={message}>
      <IconButton
        aria-label="More actions"
        isDisabled={true}
        name="navMoreHoriz"
        size="small"
        variant="ghost"
      />
    </Tooltip>
  );
}

export default LockedNavCog;
